import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const WagonForm = ({ wagonForm, handleChange, handleSubmit, handleCancel }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Date *</Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={wagonForm.date}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Station *</Form.Label>
            <Form.Select
              name="station"
              value={wagonForm.station}
              onChange={handleChange}
              required
            >
              <option value="">Select Station</option>
              <option value="Thiruvarur">Thiruvarur</option>
              <option value="Mannargudi">Mannargudi</option>
              <option value="Needamangalam">Needamangalam</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Vehicle Count *</Form.Label>
            <Form.Control
              type="number"
              name="vehicle_count"
              value={wagonForm.vehicle_count}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Advance *</Form.Label>
            <Form.Control
              type="number"
              name="advance"
              value={wagonForm.advance}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          {wagonForm.id ? "Update" : "Add"}
        </Button>
      </div>
    </Form>
  );
};

export default WagonForm;
